import moment from "moment";
import deepmerge from "deepmerge";

function removeExpiredBooks(data) {
  const clonedData = deepmerge({}, data);
  clonedData.expiredLoadStatus = "waiting";
  // Clean up old expired load status data format
  // Won't hurt for it to be there but the tests don't like it
  delete clonedData.loadingExpired;
  clonedData.books.allExpiredIsbns.forEach(
    isbn => delete clonedData.books.byIsbn[isbn]
  );
  clonedData.books.allExpiredIsbns = [];
  return clonedData;
}

export const stateToStorage = (state, user) => {
  if (state.finishedLoading) {
    return {
      data: removeExpiredBooks(state),
      licenseDate: user.info.updatedBookListAt
    };
  }
  // return undefined = no persist
};

export const storageToState = (storage, user) => {
  const lastLicenseDate = moment(user.info.updatedBookListAt);
  const storedLicenseDate = moment(storage.licenseDate);
  // Check "after" due to internal reducer state changes on license updates
  // that may not match the server response exactly
  if (storedLicenseDate.isSameOrAfter(lastLicenseDate)) {
    if (validate(storage.data)) {
      // Some users may have cached loadingExpired = false
      return removeExpiredBooks(storage.data);
    }
  }
  // return undefined = no restore
};

/**
 * @param data
 * @return {boolean} true if valid, false if not
 */
const validate = data => {
  const { allIsbns, byIsbn } = data.books;
  const now = new Date();
  return !allIsbns.some(isbn => {
    // This shouldn't happen but causes big errors if it does, so check it
    const bookData = byIsbn[isbn];
    if (!bookData) {
      return true;
    }
    // expired books don't trigger license updates via the user object
    const bookExpiration = new Date(bookData.expiresAt);
    return bookExpiration < now;
  });
};
